module.exports = __webpack_public_path__ + "static/media/img-app-setting-new-hires.372caf45.png";